/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { QAResult } from './QAResult.js';
import {
    QAResultFromJSON,
    QAResultFromJSONTyped,
    QAResultToJSON,
} from './QAResult.js';
import type { Scorecard } from './Scorecard.js';
import {
    ScorecardFromJSON,
    ScorecardFromJSONTyped,
    ScorecardToJSON,
} from './Scorecard.js';

/**
 * 
 * @export
 * @interface ScorecardResult
 */
export interface ScorecardResult {
    /**
     * 
     * @type {Scorecard}
     * @memberof ScorecardResult
     */
    scorecard?: Scorecard;
    /**
     * 
     * @type {QAResult}
     * @memberof ScorecardResult
     */
    result?: QAResult;
}

/**
 * Check if a given object implements the ScorecardResult interface.
 */
export function instanceOfScorecardResult(value: object): boolean {
    return true;
}

export function ScorecardResultFromJSON(json: any): ScorecardResult {
    return ScorecardResultFromJSONTyped(json, false);
}

export function ScorecardResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardResult {
    if (json == null) {
        return json;
    }
    return {
        
        'scorecard': json['scorecard'] == null ? undefined : ScorecardFromJSON(json['scorecard']),
        'result': json['result'] == null ? undefined : QAResultFromJSON(json['result']),
    };
}

export function ScorecardResultToJSON(value?: ScorecardResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'scorecard': ScorecardToJSON(value['scorecard']),
        'result': QAResultToJSON(value['result']),
    };
}

